export default __webpack_public_path__ + "static/char-s-32-ko-536217625e49847ae092629738afd739.webp";